export var DEFAULT_CONFIG = {
    NODE_ENV: '',
    URL: '',
    API_URL: '',
    LOCALES: {
        DEFAULT: 'us',
        ALLOWED: ['us'], //['hu', 'en', 'us'], // 'pl', 'de',
    },
    PAYMENT_METHODS: {
        BANKCARD: 1,
        STRIPE_CHECKOUT: 2,
    },
    ORDER: {
        STATUSES: {
            PENDING: 1,
            UNPAID: 2,
            PAID: 3
        }
    },
    STRIPE: {
        KEY: '',
    },
};
